export default "__VITE_ASSET__DjoJvSY7__"